const DEFAULT_BYTE_DECIMALS: number = 2;

export const formatBytes = (
  bytes: number,
  decimals: number = DEFAULT_BYTE_DECIMALS
): string => {
  if (bytes === 0) {
    return '0 Bytes';
  }

  const k = 1024;
  /* These should technically be IEC binary prefixes (KiB, MiB)
   * but common usage is 1024 KB in a MB etc.
   * Using 1000 would lead to a mismatch with OS-reported sizes
   */
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return (
    parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)).toString() +
    ' ' +
    sizes[i]
  );
};
